import React, { useEffect, useMemo, useState } from "react";
import { RotateCcw } from "lucide-react";
import api from "@/lib/api";
import DataTable from "@/components/app/DataTable";
import { StatusBadge } from "./Overview";
import { inr, pageSub, pageTitle } from "@/components/app/ui";

export default function Refunds() {
  const [refunds, setRefunds] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/vendor/refunds").then(({ data }) => setRefunds(data)).finally(() => setLoading(false)); }, []);

  const columns = useMemo(() => [
    { key: "order_number", header: "Order", cell: (r) => <span className="font-mono font-semibold text-orange-600">{r.order_number}</span> },
    { key: "amount", header: "Amount", accessor: (r) => r.amount, cell: (r) => <span className="font-semibold">{inr(r.amount)}</span> },
    { key: "reason", header: "Reason", hideBelow: "md", accessor: (r) => r.reason || "", cell: (r) => <span className="text-slate-600">{r.reason || "—"}</span> },
    { key: "status", header: "Status", cell: (r) => <StatusBadge status={r.status === "refunded" || r.status === "processed" ? "delivered" : "pending"} label={r.status} /> },
    { key: "created_at", header: "Date", accessor: (r) => r.created_at || "", cell: (r) => <span className="text-slate-600 whitespace-nowrap">{(r.created_at || "").slice(0, 10) || "—"}</span> },
  ], []);

  return (
    <div className="space-y-4" data-testid="vendor-refunds">
      <div>
        <h1 className={pageTitle}>Refunds</h1>
        <p className={pageSub}>{refunds.length} refunds processed. Refund an order from the Orders page.</p>
      </div>
      <DataTable testId="refunds-table" exportName="refunds" columns={columns} data={refunds} loading={loading}
        searchKeys={["order_number", "reason"]} searchPlaceholder="Search order or reason…" filters={[{ key: "status", label: "All statuses", accessor: (r) => r.status }]}
        dateField={{ label: "Refund date", accessor: (r) => r.created_at }} defaultSort={{ key: "created_at", dir: "desc" }}
        emptyIcon={RotateCcw} emptyTitle="No refunds yet" emptyText="Refunded orders will be listed here." />
    </div>
  );
}
